module.exports = __webpack_public_path__ + "img/957.6d0a839f.png";